import { z } from 'zod/v4';

export const DEBTOR_FILE_TYPES = [
  'invoice',
  'creditNote',
  'termsAndConditions',
  'clientPortal',
] as const;

export type DebtorFileType = (typeof DEBTOR_FILE_TYPES)[number];

export const DebtorFileTypeSchema = z.enum([...DEBTOR_FILE_TYPES]);
